import { images } from "../../assets/Images/assetsImages"

const HeroSection = () => {
  return (
    <section className="w-full h-full flex flex-col">
        <div className="w-full h-screen flex bg-[#F5E9D7] relative">
            <div className="w-full h-screen flex justify-end items-center lg:hidden">
                    <img src={images.AboutHeroImage} alt="AboutHeroImage" className="opacity-40 w-full h-full object-cover"></img>
            </div>
            <div className="absolute inset-0 lg:relative lg:w-[50%] flex flex-col justify-center items-center lg:items-start font-playfair px-[50px] 2xl:px-[100px] 3xl:px-[120px] text-center lg:text-start text-black">
                <h1 className="font-bold font-playfair text-5xl 2xl:text-5xl mb-4 3xl:mb-6 mt-[50px] xl:mt-[80px] 2xl:mt-10">ABOUT US</h1>
                <h2 className="font-medium text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl italic my-4">Baking Dreams Into Reality - One Bite at a Time</h2>
                <p className="font-medium font-montserrat text-xl xl:text-2xl 2xl:text-[18px] 3xl:text-[2xl] mt-4 3xl:mt-10 xl:leading-normal">Welcome to Symphonys, a haven for baked delights and warm smiles. Inspired by the art of baking and fueled by a love for creating unforgettable flavors, 
                    we craft everything with care and passion. Every loaf, pastry, and dessert tells a story of dedication, quality, and a sprinkle of magic.</p>
            </div>
            <div className="hidden lg:flex w-[50%] justify-end items-center lg:mt-5 xl:mt-0">
                <div className="w-[90%] h-[50%] 2xl:h-[60%] 3xl:h-[50%] rounded-tl-[280px] xl:rounded-tl-[350px] 2xl:rounded-tl-[420px]">
                    <img src={images.AboutHeroImage} alt="AboutHeroImage" className="rounded-tl-[280px] xl:rounded-tl-[350px] 2xl:rounded-tl-[420px]"></img>
                </div>
            </div>
        </div>
    </section>
  )
}

export default HeroSection
